/* eslint-disable no-unused-expressions */
import { createGlobalStyle } from 'styled-components';
import media from './media';

const GlobalStyle = createGlobalStyle`
  html {
    font-size: 6.5px!important;
    
    ${media.desktop`
      font-size: 8px!important;
    `}

    ${media.mediumDesktop`
      font-size: 9px!important;
    `}
    
    ${media.largeDesktop`
      font-size: 10px!important;
    `}
  }

  body {
    margin: 0!important;
    padding: 0!important;
    font-family: 'Montserrat', 'Open Sans', sans-serif!important;


    ${media.desktop`
      min-width: 1024px;
    `}

  }

  * {
    box-sizing: border-box;
  }
  
  h1, h2, h3, h4, h5, h6{
    margin:0;
    font-weight:normal;
  }

`;

export default GlobalStyle;
